// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid_FMNnT {
  display : grid;
  grid-template-columns: auto 1fr;
  column-gap : var( --size-padMedium, 16px );
  row-gap : var( --size-padMedium, 16px );
  align-items: center;
  justify-items: start;
  justify-content: left;
  padding : var( --size-padMedium, 16px );
}

.fill_QSm9R {
  grid-column: 1 / span 2;
}

.sub_EgzIA {
  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
}

.pad_ZAWxt {
  padding : var( --size-padLarge, 16px )
}

.hint_oxShO {
  max-width: 300px;
  margin-bottom : var( --size-padLarge, 16px )
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/map/editors/Grid.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,0CAA0C;EAC1C,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF","sourcesContent":["\n.grid {\n  display : grid;\n  grid-template-columns: auto 1fr;\n  column-gap : var( --size-padMedium, 16px );\n  row-gap : var( --size-padMedium, 16px );\n  align-items: center;\n  justify-items: start;\n  justify-content: left;\n  padding : var( --size-padMedium, 16px );\n}\n\n.fill {\n  grid-column: 1 / span 2;\n}\n\n.sub {\n  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n}\n\n.pad {\n  padding : var( --size-padLarge, 16px )\n}\n\n.hint {\n  max-width: 300px;\n  margin-bottom : var( --size-padLarge, 16px )\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_FMNnT`,
	"fill": `fill_QSm9R`,
	"sub": `sub_EgzIA`,
	"pad": `pad_ZAWxt`,
	"hint": `hint_oxShO`
};
export default ___CSS_LOADER_EXPORT___;
